import { css } from '@withjoy/joykit';

/** Shared underline treatment for links and text actions, including labels inside clickable cards. */
export const dottedUnderlineStyles = css`
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-underline-offset: 25%;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
